document.addEventListener("DOMContentLoaded", () => {
  // Buttons
  const registerSubmitButton = document.getElementById('register_submit_btn');

  // Forms
    const registerCustomerForm = document.getElementById('create_customer');

    const registerTagsField = document.getElementById('membership_registration_tags');

    const partnerCodeField = document.getElementById('membership_registration_partner_code');

    registerSubmitButton.addEventListener('click', (event) => {
      event.preventDefault();

      if(partnerCodeField !== undefined && partnerCodeField.value !== "") {
        const partnerCode = partnerCodeField.value.toUpperCase();
        let tagsValue = registerTagsField.value + `,partner-code-applied,${partnerCode}`;
        registerTagsField.value = tagsValue;
        console.log(`tagsValue val: ${tagsValue}`);
      }

      registerCustomerForm.submit();
    });

  });   